import React, { Component } from 'react';
import { array } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';

import EsmsCard from '../../components/EsmsCard';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './ErpAgentsCard.module.css';

class ErpAgentsCard extends Component {
    static propTypes = {
        erpAgents: array
    }

    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/iothub/erpagents' + history.location.search);
    }

    render() {
        let { currentScopes, erpAgents } = this.props;

        return (
            <EsmsCard
                title="FSM Integrations"
                imagePath="/assets/images/erpAgentIconColor.svg"
            >
                <div className={classes.innerContainer}>
                    <div className={classes.erpAgentsInfo}>
                        <div>
                            <span className={classes.title}>Total Agents</span>
                            <span className={classes.data}>{erpAgents.length || 0}</span>
                        </div>
                        <div>
                            <span className={classes.title}>Connected Agents</span>
                            <span className={classes.data}>
                                {erpAgents.filter(agent => agent.connectionStatus).length || 0}
                            </span>
                        </div>
                    </div>
                    {
                        isAllowed(currentScopes, Permissions('iothubRead')) &&
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handlePageRoute}
                        >
                            Manage FSM Integrations
                        </Button>
                    }
                </div>
            </EsmsCard>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentScopes: state.core.currentScopes,
        erpAgents:     state.erpAgent.erpAgents
    };
};

export default withRouter(connect(mapStateToProps)(ErpAgentsCard));
